import React, { Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _get from 'lodash/get'
import _dropRight from 'lodash/dropRight'
import history from '@source/history'
import LazyLoad from '@components/common/Lazyload'
import Carousel from '@components/carousel'
import PlaylistCard from '@components/playlist-card'
import VideoCard from '@components/video-card'
import PlaylistError from '@components/common/error'
import CarouselContainer from '@components/carousel-container'
import BannerCarousel from '@components/banner-carousel'

import Mola from '@api/mola'
import playlistAction from '@actions/playlist'
import { setRuntimeVariable } from '@actions/runtime'

import {
  getContentTypeName,
  getErrorCode,
  setBackToPageTitle,
  arrayToChunk,
  PlaylistStyle,
  ContentStyle,
  getSpecialRibbon,
  ImageSize,
} from '@source/lib/globalUtil'
import { isMatchLive, isMatchPassed } from '@source/lib/dateTimeUtil'
import { placeholderBlankPortrait, placeholderBlankLandscape, logoOri } from '@global/imageUrl'
import MolaOriginal from './original'
import PlaylistHeader from './playlist-header'

import {
  playlistHeadDesktop,
  playlistHeadMobile,
  playlistListContainer,
  playlistList,
  imageContainer,
  imagePlaceholder,
  imageWrapper,
  CarouselWrapper,
  playlistCarousel,
  playlistCarouselContainer,
  PlaylistInlineWrapper,
  MolaOriCarouselWrapper,
  BannerWrapper,
} from './style'

// const IMAGE_SIZE = {
//   LANDSCAPE: 1,
//   PORTRAIT: 2,
//   PORTRAIT23: 3,
// }
class PlaylistWithStyle extends React.Component {
  state = {
    carouselOriHeight: 0,
  }

  handleCarouselOri = height => {
    this.setState({
      carouselOriHeight: height,
    })
  }

  handleOnClick = id => {
    if (id) {
      const route = setBackToPageTitle(`/watch?v=${id}`)
      window.location.href = route
    }
  }

  handleCardClick = video => {
    const obj = {
      articles: () => `/articles/${video.id}`,
      banners: () => video.link,
      videos: () => {
        const videoTypesRedirectUri = {
          // linear: `/channels/${video.id}`,
          default: setBackToPageTitle(`/watch?v=${video.id}`),
        }

        const contentTypeName = getContentTypeName(_get(video, 'contentType', 'default'))
        const linearRedirectId = _get(this.props.configParams, 'data.linear_redirect_id', [])
        let redirectUrl = videoTypesRedirectUri.default
        if (contentTypeName == 'linear') {
          if (linearRedirectId.includes(video.id)) {
            redirectUrl = videoTypesRedirectUri.default
          } else {
            redirectUrl = videoTypesRedirectUri[contentTypeName]
          }
        }
        return redirectUrl
      },
    }

    if (video) {
      /** only execute when a video object exist */
      if (video.type == 'banners') {
        window.location.href = obj[video.type]()
      } else if (video.type == 'playlists') {
        let route = setBackToPageTitle(`/categories/${video.id}`, video.title)
        const isSingleVideo = getContentTypeName(video.contentType) === 'single-video'

        if (isSingleVideo) {
          route = setBackToPageTitle(`/watch?v=${video.id}`)
          history.push(route)
        } else {
          Mola.getPlaylistChild({ id: video.id, platformId: this.props.runtime.platformId }).then(result => {
            const filterVisibility = result
              ? result.data.filter(dt => {
                return dt.visibility === 1
              })
              : []
            /** force to video detail if single child and type videos */
            if (filterVisibility.length === 1 && filterVisibility[0].type === 'videos') {
              route = setBackToPageTitle(`/watch?v=${filterVisibility[0].id}`)
            }
            history.push(route)
          })
        }
      } else {
        history.push(obj[video.type]())
      }
    } else {
      alert(`Mola does NOT recognized this link \n${JSON.stringify(video)}`)
    }
  }

  getImageSize = ({ isMobile, isRatio23, bg, isPortrait }) => {
    let imgSize = { src: null, srcset: null, sizes: null }
    if (isPortrait) {
      const mobileSizeQuery = isRatio23 ? 'w=180&h=270' : 'w=270&h=480'

      imgSize.src = `${bg}?${mobileSizeQuery}`
      imgSize.srcset = isRatio23
        ? `${bg}?w=180&h=270 180w, ${bg}?w=400&h=600 400w, ${bg}?w=640&h=960 640w, ${bg}?w=720&h=1080 720w`
        : `${bg}?w=270&h=480 270w, ${bg}?w=450&h=800 450w, ${bg}?w=540&h=960 540w, ${bg}?w=720&h=1280 720w`
      imgSize.sizes = '(min-width: 1024px) 15vw, 100px'
    } else {
      imgSize.src = `${bg}?w=360`
      imgSize.srcset = `${bg}?w=368 368w,${bg}?w=480 480w, ${bg}?w=640 640w, ${bg}?w=768 768w`
      imgSize.sizes = '(min-width: 768px) 20vw, 100px'
    }
    return imgSize
  }

  render() {
    const {
      playlist: {
        children: { data, meta, reminders },
        playlists: {
          meta: { title: parentTitle, id: parentId, forceChildStyle },
          data: playlistData,
        },
      },
      isMobile,
      configParams,
      handleOnClick,
      isCategories = false,
      hasHub,
    } = this.props
    const { carouselOriHeight } = this.state
    const molaOriHeight = carouselOriHeight ? '0px' : isMobile ? '395px' : '31rem'
    const defaultPermissionCard = _get(configParams, 'data.default_permission_card', 3)
    const minViewAll = _get(configParams, 'data.playlist_view_all_min', 7)
    const maxShowCard = _get(configParams, 'data.playlist_max_card', 15)
    return (
      <>
        {playlistData &&
          playlistData.map((py, playlistIndex) => {
            let playlistStyle = py.playlistStyle || 'default', //_get(py, "playlistStyle", "default"),
              contentStyle =
                py.contentStyle || _get(configParams, 'data.default_content_style', ContentStyle.BLANK_PORTRAIT),
              childrenList = _get(data, `[${playlistIndex}]`, null),
              childrenData = _get(data, `[${playlistIndex}].data`, []),
              childrenReminders = _get(data, `[${playlistIndex}].reminders`, null),
              childrenTitle = _get(data, `[${playlistIndex}].meta.title`, null),
              contentTypeName = getContentTypeName(_get(py, 'contentType', 'vod'))

            let pyStyle =
              playlistStyle === 'default'
                ? _get(configParams, 'data.default_playlist_style', PlaylistStyle.MOVIE_PORTRAIT)
                : playlistStyle

            if (forceChildStyle) {
              pyStyle = forceChildStyle
              playlistStyle = forceChildStyle
            }

            const showVideosOnly =
              py.id === parentId && data.length === 1 && _get(data, '[0].meta.type', '') === 'videos'

            //read content style
            const childrenStyle = {
              isEnable: false,
              hasTitle: false,
              hasDescription: false,
              isMatch: false,
              hasLeague: false,
              hasDate: false,
              isDetailHidden: false,
              isLandscape: false,
              hasDuration: true,
              isRatio23: false,
            }
            const remindersStatus = _get(childrenReminders, 'meta.status', '')
            if (showVideosOnly) {
              if (
                contentStyle == ContentStyle.BLANK_PORTRAIT ||
                contentStyle == ContentStyle.BLANK_LANDSCAPE ||
                contentStyle == ContentStyle.BLANK_PORTRAIT_23
              ) {
                childrenStyle.isDetailHidden = true
                childrenStyle.isRatio23 = contentStyle == ContentStyle.BLANK_PORTRAIT_23
                childrenStyle.isLandscape = contentStyle == ContentStyle.BLANK_LANDSCAPE
              } else if (
                contentStyle == ContentStyle.TITLE_PORTRAIT ||
                contentStyle == ContentStyle.TITLE_LANDSCAPE ||
                contentStyle == ContentStyle.TITLE_PORTRAIT_23
              ) {
                childrenStyle.hasTitle = true
                childrenStyle.isRatio23 = contentStyle == ContentStyle.TITLE_PORTRAIT_23
                childrenStyle.isLandscape = contentStyle == ContentStyle.TITLE_LANDSCAPE
              } else if (
                contentStyle == ContentStyle.MOVIE_PORTRAIT ||
                contentStyle == ContentStyle.MOVIE_LANDSCAPE ||
                contentStyle == ContentStyle.MOVIE_PORTRAIT_23
              ) {
                childrenStyle.hasTitle = true
                childrenStyle.hasDescription = true
                childrenStyle.isRatio23 = contentStyle == ContentStyle.MOVIE_PORTRAIT_23
                childrenStyle.isLandscape = contentStyle == ContentStyle.MOVIE_LANDSCAPE
              } else if (
                contentStyle == ContentStyle.MATCH_PORTRAIT ||
                contentStyle == ContentStyle.MATCH_LANDSCAPE ||
                contentStyle == ContentStyle.MATCH_PORTRAIT_23
              ) {
                childrenStyle.hasTitle = true
                childrenStyle.isMatch = true
                childrenStyle.hasDate = true
                childrenStyle.hasLeague = true
                childrenStyle.hasDuration = false
                childrenStyle.isRatio23 = contentStyle == ContentStyle.MATCH_PORTRAIT_23
                childrenStyle.isLandscape = contentStyle == ContentStyle.MATCH_LANDSCAPE
              } else if (
                contentStyle == ContentStyle.HIGHLIGHT_PORTRAIT ||
                contentStyle == ContentStyle.HIGHLIGHT_LANDSCAPE ||
                contentStyle == ContentStyle.HIGHLIGHT_PORTRAIT_23
              ) {
                childrenStyle.hasTitle = true
                childrenStyle.isMatch = true
                childrenStyle.hasLeague = true
                childrenStyle.isRatio23 = contentStyle == ContentStyle.HIGHLIGHT_PORTRAIT_23
                childrenStyle.isLandscape = contentStyle == ContentStyle.HIGHLIGHT_LANDSCAPE
              } else {
                childrenStyle.hasTitle = true
                childrenStyle.hasDescription = true
              }

              if (isCategories) {
                childrenStyle.hasDuration = false
              }

              if (childrenStyle.isLandscape) {
                return (
                  <Fragment key={py.id}>
                    {childrenData.map((obj, idx) => {
                      const tenMinutesBefore = obj.startTime - 10 * 60
                      let reminder = null
                      if (childrenReminders && remindersStatus === 'success') {
                        if (getContentTypeName(obj.contentType) === 'live' && !isMatchPassed(tenMinutesBefore)) {
                          childrenReminders.data.map(c => {
                            if (c.id === obj.id) {
                              reminder = {
                                status: c.status,
                              }
                            }
                          })
                          if (!reminder) {
                            reminder = {
                              status: 0,
                            }
                          }
                        }
                      }
                      let isLive = null
                      if (contentStyle == ContentStyle.MATCH_PORTRAIT || contentStyle == ContentStyle.MATCH_LANDSCAPE) {
                        isLive = obj.startTime && obj.endTime && isMatchLive(obj.startTime, obj.endTime)
                      }
                      const description = obj.shortDescription || null
                      const ribbon = getSpecialRibbon(obj, ImageSize.LANDSCAPE)
                      const bg = childrenStyle.isLandscape
                        ? _get(obj, 'background.landscape', placeholderBlankLandscape)
                        : _get(obj, 'background.portrait', placeholderBlankPortrait)
                      const imgSize = this.getImageSize({
                        isMobile,
                        isRatio23: childrenStyle.isRatio23,
                        bg,
                        isPortrait: !childrenStyle.isLandscape,
                      })
                      return (
                        <PlaylistInlineWrapper isLandscape isMobile={isMobile} key={idx}>
                          <PlaylistCard
                            {...obj}
                            key={obj.id}
                            onClick={() => (handleOnClick ? handleOnClick : this.handleCardClick(obj))}
                            src={imgSize.src}
                            srcset={imgSize.srcset}
                            sizes={imgSize.sizes}
                            isDetailHidden={childrenStyle.isDetailHidden}
                            title={childrenStyle.hasTitle ? obj.title : null}
                            description={childrenStyle.hasDescription ? description : null}
                            isMatch={childrenStyle.isMatch}
                            startTime={childrenStyle.hasDate ? obj.startTime : null}
                            league={childrenStyle.hasLeague ? obj.league : null}
                            duration={childrenStyle.hasDuration ? obj.duration : null}
                            isLive={isLive}
                            defaultPermissionCard={defaultPermissionCard}
                            reminder={reminder}
                            ribbon={ribbon}
                          />
                        </PlaylistInlineWrapper>
                      )
                    })}
                  </Fragment>
                )
              } else {
                return (
                  <Fragment key={py.id}>
                    {childrenData.map((obj, idx) => {
                      const tenMinutesBefore = obj.startTime - 10 * 60
                      let reminder = null
                      if (childrenReminders && remindersStatus === 'success') {
                        if (getContentTypeName(obj.contentType) === 'live' && !isMatchPassed(tenMinutesBefore)) {
                          childrenReminders.data.map(c => {
                            if (c.id === obj.id) {
                              reminder = {
                                status: c.status,
                              }
                            }
                          })
                          if (!reminder) {
                            reminder = {
                              status: 0,
                            }
                          }
                        }
                      }

                      let isLive = null
                      if (contentStyle == ContentStyle.MATCH_PORTRAIT || contentStyle == ContentStyle.MATCH_LANDSCAPE) {
                        isLive = obj.startTime && obj.endTime && isMatchLive(obj.startTime, obj.endTime)
                      }
                      const bg = childrenStyle.isLandscape
                        ? _get(obj, 'background.landscape', placeholderBlankLandscape)
                        : _get(obj, 'background.portrait', placeholderBlankPortrait)
                      const imgSize = this.getImageSize({
                        isMobile,
                        isRatio23: childrenStyle.isRatio23,
                        bg,
                        isPortrait: !childrenStyle.isLandscape,
                      })
                      const description = obj.shortDescription || null
                      const ribbon = getSpecialRibbon(
                        obj,
                        childrenStyle.isRatio23 ? ImageSize.PORTRAIT23 : ImageSize.PORTRAIT,
                      )
                      return (
                        <PlaylistInlineWrapper isMobile={isMobile} key={idx}>
                          <VideoCard
                            {...obj}
                            key={obj.id}
                            onClick={() => (handleOnClick ? handleOnClick : this.handleCardClick(obj))}
                            src={imgSize.src}
                            srcset={imgSize.srcset}
                            sizes={imgSize.sizes}
                            isDetailHidden={true}
                            isDetailHidden={childrenStyle.isDetailHidden}
                            title={childrenStyle.hasTitle ? obj.title : null}
                            description={childrenStyle.hasDescription ? description : null}
                            isMatch={childrenStyle.isMatch}
                            startTime={childrenStyle.hasDate ? obj.startTime : null}
                            league={childrenStyle.hasLeague ? obj.league : null}
                            duration={childrenStyle.hasDuration ? obj.duration : null}
                            isLive={isLive}
                            isRatio23={childrenStyle.isRatio23}
                            defaultPermissionCard={defaultPermissionCard}
                            reminder={reminder}
                            ribbon={ribbon}
                          />
                        </PlaylistInlineWrapper>
                      )
                    })}
                  </Fragment>
                )
              }
            }

            if (contentTypeName === 'banner' && childrenList) {
              // const ribbon = getSpecialRibbon(py, ImageSize.LANDSCAPE)
              return (
                <>
                  {
                    childrenData.length > 0 &&
                    <BannerWrapper key={py.id}>
                      <BannerCarousel banners={childrenList} isMobile={isMobile}>
                        {childrenData.length > 0 &&
                          childrenData.map(obj => {
                            const ribbon = getSpecialRibbon(obj, ImageSize.LANDSCAPE)
                            return (
                              <PlaylistCard
                                transitionMode={'scroll'}
                                key={obj.id}
                                onClick={() => this.handleCardClick(obj)}
                                alt={obj.title}
                                src={`${obj.background.landscape}?w=${isMobile ? '450' : '800'}`}
                                isDetailHidden
                                bannerCard
                                onHoverBorder={false}
                                ribbon={ribbon}
                              />
                            )
                          })}
                      </BannerCarousel>
                    </BannerWrapper>}
                </>
              )
            } else if (
              pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT ||
              pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_23 ||
              pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_FULL ||
              pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_FULL_23 ||
              pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_TITLE ||
              pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_TITLE_23
            ) {
              childrenStyle.isRatio23 =
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_23 ||
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_FULL_23 ||
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_TITLE_23
              const mobileSizeQuery = childrenStyle.isRatio23 ? 'w=180&h=270' : 'w=270&h=480',
                desktopSizeQuery = childrenStyle.isRatio23 ? 'w=400&h=600' : 'w=450&h=800'
              const imgSizeQuery = isMobile ? mobileSizeQuery : desktopSizeQuery
              const thumbnailBg = _get(py, 'images.cover.portrait', placeholderBlankPortrait)
              childrenStyle.hasTitle =
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_FULL ||
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_FULL_23 ||
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_TITLE ||
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_TITLE_23
              childrenStyle.hasDescription =
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_FULL ||
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_FULL_23
              childrenStyle.isDetailHidden =
                pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT || pyStyle == PlaylistStyle.CATEGORIES_PORTRAIT_23
              const redirectToVideo = childrenData.length == 1 && childrenData[0].type == 'videos'
              py.type = redirectToVideo ? 'videos' : py.type
              py.id = redirectToVideo ? childrenData[0].id : py.id
              const description = py.shortDescription || null
              const ribbon = getSpecialRibbon(py, childrenStyle.isRatio23 ? ImageSize.PORTRAIT23 : ImageSize.PORTRAIT)
              return (
                <PlaylistInlineWrapper isMobile={isMobile} key={py.id}>
                  <VideoCard
                    {...py}
                    key={py.id}
                    onClick={() => (handleOnClick ? handleOnClick(py) : this.handleCardClick(py))}
                    src={`${thumbnailBg}?${imgSizeQuery}`}
                    isDetailHidden={childrenStyle.isDetailHidden}
                    defaultPermissionCard={defaultPermissionCard}
                    isRatio23={childrenStyle.isRatio23}
                    duration={null}
                    title={childrenStyle.hasTitle ? py.title : null}
                    description={childrenStyle.hasDescription ? description : null}
                    ribbon={ribbon}
                  />
                </PlaylistInlineWrapper>
              )
            } else if (
              pyStyle == PlaylistStyle.CATEGORIES_LANDSCAPE ||
              pyStyle == PlaylistStyle.CATEGORIES_LANDSCAPE_FULL ||
              pyStyle == PlaylistStyle.CATEGORIES_LANDSCAPE_TITLE
            ) {
              const thumbnailBg = _get(py, 'images.cover.landscape', placeholderBlankLandscape)
              childrenStyle.hasTitle =
                pyStyle == PlaylistStyle.CATEGORIES_LANDSCAPE_FULL ||
                pyStyle == PlaylistStyle.CATEGORIES_LANDSCAPE_TITLE
              childrenStyle.hasDescription = pyStyle == PlaylistStyle.CATEGORIES_LANDSCAPE_FULL
              childrenStyle.isDetailHidden = pyStyle == PlaylistStyle.CATEGORIES_LANDSCAPE
              const redirectToVideo = childrenData.length == 1 && childrenData[0].type == 'videos'
              py.type = redirectToVideo ? 'videos' : py.type
              py.id = redirectToVideo ? childrenData[0].id : py.id
              const description = py.shortDescription || null
              const ribbon = getSpecialRibbon(py, ImageSize.LANDSCAPE)
              return (
                <PlaylistInlineWrapper isLandscape isMobile={isMobile}>
                  <PlaylistCard
                    {...py}
                    key={py.id}
                    onClick={() => (handleOnClick ? handleOnClick(py) : this.handleCardClick(py))}
                    src={`${thumbnailBg}?w=768`}
                    isDetailHidden={childrenStyle.isDetailHidden}
                    defaultPermissionCard={defaultPermissionCard}
                    duration={null}
                    title={childrenStyle.hasTitle ? py.title : null}
                    description={childrenStyle.hasDescription ? description : null}
                    ribbon={ribbon}
                  />
                </PlaylistInlineWrapper>
              )
            } else if (
              pyStyle == PlaylistStyle.ORIGINALS_LANDSCAPE ||
              pyStyle == PlaylistStyle.ORIGINALS_PORTRAIT ||
              pyStyle == PlaylistStyle.ORIGINALS_PORTRAIT_23
            ) {
              return (
                <MolaOriCarouselWrapper minHeight={molaOriHeight} key={py.id}>
                  <MolaOriginal
                    id={py.viewMorePlaylistId ? py.viewMorePlaylistId : py.id}
                    data={childrenData}
                    onClick={oriObj => this.handleCardClick(oriObj)}
                    isMobile={isMobile}
                    framePadding={!isMobile ? '0rem' : '0rem 0rem 0rem 5px'}
                    logoOri={logoOri}
                    headerTitle={childrenTitle}
                    carouselHeightCallback={this.handleCarouselOri}
                    setBackToPageTitle={setBackToPageTitle}
                    isLandscape={pyStyle == PlaylistStyle.ORIGINALS_LANDSCAPE}
                    isRatio23={pyStyle == PlaylistStyle.ORIGINALS_PORTRAIT_23}
                    defaultPermissionCard={defaultPermissionCard}
                    key={py.id}
                    getRibbon={getSpecialRibbon}
                  />
                </MolaOriCarouselWrapper>
              )
            } else {
              if (
                playlistStyle == PlaylistStyle.BLANK_PORTRAIT ||
                playlistStyle == PlaylistStyle.BLANK_LANDSCAPE ||
                playlistStyle == PlaylistStyle.BLANK_PORTRAIT_23
              ) {
                childrenStyle.isDetailHidden = true
                childrenStyle.isRatio23 = playlistStyle == PlaylistStyle.BLANK_PORTRAIT_23
                childrenStyle.isLandscape = playlistStyle == PlaylistStyle.BLANK_LANDSCAPE
              } else if (
                playlistStyle == PlaylistStyle.TITLE_PORTRAIT ||
                playlistStyle == PlaylistStyle.TITLE_LANDSCAPE ||
                playlistStyle == PlaylistStyle.TITLE_PORTRAIT_23
              ) {
                childrenStyle.hasTitle = true
                childrenStyle.isRatio23 = playlistStyle == PlaylistStyle.TITLE_PORTRAIT_23
                childrenStyle.isLandscape = playlistStyle == PlaylistStyle.TITLE_LANDSCAPE
              } else if (
                playlistStyle == PlaylistStyle.MOVIE_PORTRAIT ||
                playlistStyle == PlaylistStyle.MOVIE_LANDSCAPE ||
                playlistStyle == PlaylistStyle.MOVIE_PORTRAIT_23 ||
                playlistStyle == PlaylistStyle.MOVIE_LANDSCAPE_SECTION_FULL ||
                playlistStyle == PlaylistStyle.MOVIE_PORTRAIT_SECTION_FULL_23 ||
                playlistStyle == PlaylistStyle.MOVIE_PORTRAIT_SECTION_FULL
              ) {
                childrenStyle.hasTitle = true
                childrenStyle.hasDescription = true
                childrenStyle.isRatio23 =
                  playlistStyle == PlaylistStyle.MOVIE_PORTRAIT_23 ||
                  playlistStyle == PlaylistStyle.MOVIE_PORTRAIT_SECTION_FULL_23
                childrenStyle.isLandscape =
                  playlistStyle == PlaylistStyle.MOVIE_LANDSCAPE ||
                  playlistStyle == PlaylistStyle.MOVIE_LANDSCAPE_SECTION_FULL
              } else if (
                playlistStyle == PlaylistStyle.MATCH_PORTRAIT ||
                playlistStyle == PlaylistStyle.MATCH_LANDSCAPE ||
                playlistStyle == PlaylistStyle.MATCH_PORTRAIT_23
              ) {
                childrenStyle.hasTitle = true
                childrenStyle.isMatch = true
                childrenStyle.hasDate = true
                childrenStyle.hasLeague = true
                childrenStyle.hasDuration = true
                childrenStyle.isRatio23 = playlistStyle == PlaylistStyle.MATCH_PORTRAIT_23
                childrenStyle.isLandscape = playlistStyle == PlaylistStyle.MATCH_LANDSCAPE
              } else if (
                playlistStyle == PlaylistStyle.HIGHLIGHT_PORTRAIT ||
                playlistStyle == PlaylistStyle.HIGHLIGHT_LANDSCAPE ||
                playlistStyle == PlaylistStyle.HIGHLIGHT_PORTRAIT_23
              ) {
                childrenStyle.hasTitle = true
                childrenStyle.isMatch = true
                childrenStyle.hasLeague = true
                childrenStyle.isRatio23 = playlistStyle == PlaylistStyle.HIGHLIGHT_PORTRAIT_23
                childrenStyle.isLandscape = playlistStyle == PlaylistStyle.HIGHLIGHT_LANDSCAPE
              } else {
                childrenStyle.hasTitle = true
                childrenStyle.hasDescription = true
              }
              let slideToShow = isMobile ? (childrenStyle.isLandscape ? 2 : 3) : childrenStyle.isLandscape ? 4 : 6
              let cHeight = childrenStyle.isLandscape ? '20rem' : ' 37rem'
              if (isMobile) {
                cHeight = childrenStyle.isLandscape ? '9rem' : ' 15rem'
              }

              if (isCategories) {
                childrenStyle.hasDuration = false
              }

              const homeViewMoreMappingLinks = _get(configParams, 'quickAccess.home_featured_view_more_mappings', {})

              const routeCategories = setBackToPageTitle(`/categories/${py.id}`, py.title)
              const limitedChildrenData =
                childrenData.length > maxShowCard
                  ? _dropRight(childrenData, childrenData.length - maxShowCard)
                  : childrenData

              const showDescription =
                playlistStyle == PlaylistStyle.MOVIE_LANDSCAPE_SECTION_FULL ||
                playlistStyle == PlaylistStyle.MOVIE_PORTRAIT_SECTION_FULL ||
                playlistStyle == PlaylistStyle.MOVIE_PORTRAIT_SECTION_FULL_23
              const headerDescription = py.shortDescription || null
              return (
                <LazyLoad
                  containerClassName={playlistListContainer}
                  containerStyle={{
                    marginRight: isCategories ? '1.6rem' : '',
                    marginTop: hasHub && playlistIndex === 0 ? isMobile ? '32px' : '4rem' : '',
                  }}
                  key={py.id}
                >
                  <div className={playlistList}>
                    {/* {py.title !== parentTitle && ( */}
                    <PlaylistHeader
                      title={py.title}
                      showTitle={true}
                      showViewAll={childrenData.length > minViewAll}
                      viewAllLink={homeViewMoreMappingLinks[py.id] || routeCategories}
                      description={showDescription ? headerDescription : ''}
                    />
                    {/* )} */}
                    <CarouselContainer
                      isMobile={isMobile}
                      slideToShow={slideToShow}
                      initialHeight={cHeight}
                      carouselClassName={playlistCarousel}
                      withoutControls={limitedChildrenData.length <= slideToShow}
                    >
                      {limitedChildrenData.map((obj, idx) => {
                        const tenMinutesBefore = obj.startTime - 10 * 60
                        let reminder = null
                        if (childrenReminders && remindersStatus === 'success') {
                          if (getContentTypeName(obj.contentType) === 'live' && !isMatchPassed(tenMinutesBefore)) {
                            childrenReminders.data.map(c => {
                              if (c.id === obj.id) {
                                reminder = {
                                  status: c.status,
                                }
                              }
                            })
                            if (!reminder) {
                              reminder = {
                                status: 0,
                              }
                            }
                          }
                        }
                        let isLive = null
                        if (
                          playlistStyle == PlaylistStyle.MATCH_PORTRAIT ||
                          playlistStyle == PlaylistStyle.MATCH_LANDSCAPE
                        ) {
                          isLive = obj.startTime && obj.endTime && isMatchLive(obj.startTime, obj.endTime)
                        }
                        const bg = childrenStyle.isLandscape
                          ? _get(obj, 'background.landscape', placeholderBlankLandscape)
                          : _get(obj, 'background.portrait', placeholderBlankPortrait)
                        const description = obj.shortDescription || null
                        const imgSize = this.getImageSize({
                          isMobile,
                          isRatio23: childrenStyle.isRatio23,
                          bg,
                          isPortrait: !childrenStyle.isLandscape,
                        })
                        if (childrenStyle.isLandscape) {
                          const ribbon = getSpecialRibbon(obj, ImageSize.LANDSCAPE)
                          return (
                            <PlaylistCard
                              key={obj.id}
                              {...obj}
                              onClick={() => (handleOnClick ? handleOnClick(obj) : this.handleCardClick(obj))}
                              src={imgSize.src}
                              srcset={imgSize.srcset}
                              sizes={imgSize.sizes}
                              isDetailHidden={childrenStyle.isDetailHidden}
                              title={childrenStyle.hasTitle ? obj.title : null}
                              description={childrenStyle.hasDescription ? description : null}
                              isMatch={childrenStyle.isMatch}
                              startTime={childrenStyle.hasDate ? obj.startTime : null}
                              league={childrenStyle.hasLeague ? obj.league : null}
                              duration={childrenStyle.hasDuration ? obj.duration : null}
                              isLive={isLive}
                              defaultPermissionCard={defaultPermissionCard}
                              reminder={reminder}
                              ribbon={ribbon}
                            />
                          )
                        } else {
                          const ribbon = getSpecialRibbon(
                            obj,
                            childrenStyle.isRatio23 ? ImageSize.PORTRAIT23 : ImageSize.PORTRAIT,
                          )
                          return (
                            <VideoCard
                              key={obj.id}
                              {...obj}
                              onClick={() => (handleOnClick ? handleOnClick(obj) : this.handleCardClick(obj))}
                              src={imgSize.src}
                              srcset={imgSize.srcset}
                              sizes={imgSize.sizes}
                              isDetailHidden={childrenStyle.isDetailHidden}
                              title={childrenStyle.hasTitle ? obj.title : null}
                              description={childrenStyle.hasDescription ? description : null}
                              isMatch={childrenStyle.isMatch}
                              startTime={childrenStyle.startTime}
                              league={childrenStyle.hasLeague ? obj.league : null}
                              duration={childrenStyle.hasDuration ? obj.duration : null}
                              isLive={isLive}
                              defaultPermissionCard={defaultPermissionCard}
                              isRatio23={childrenStyle.isRatio23}
                              reminder={reminder}
                              ribbon={ribbon}
                            />
                          )
                        }
                      })}
                    </CarouselContainer>
                  </div>
                </LazyLoad>
              )
            }
          })}
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    runtime: { ...state.runtime },
  }
}

export default connect(mapStateToProps)(PlaylistWithStyle)
